export class CacheOptions {
    public toolDetailsId: number;
    public operationId: number;

    constructor(options: any = {}) {
       this.toolDetailsId = options.toolDetailsId || null;
       this.operationId = options.operationId || null;
    }
}
